export default (asyncStatusList = []) => ({
  isInitial: asyncStatusList.some(({ isInitial }) => isInitial),
  isBusy: asyncStatusList.some(({ isBusy }) => isBusy),
  isSuccessful: asyncStatusList.some(({ isSuccessful }) => isSuccessful),
  isError: asyncStatusList.some(({ isError }) => isError),
  errorMessage: asyncStatusList.some(({ errorMessage }) => errorMessage),
})
